// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Footer-module--bx--text-truncate--end--2bMuB";
export var bxTextTruncateFront = "Footer-module--bx--text-truncate--front--2fDiZ";
export var content = "Footer-module--content--3_aN1";
export var footer = "Footer-module--footer--3_YrI";
export var grid = "Footer-module--grid--2BqUL";
export var listItem = "Footer-module--listItem--2CQ5e";
export var logo = "Footer-module--logo--3ZTyU";
export var nav = "Footer-module--nav--8jcdf";